/**
 * Converts an array of objects to CSV format
 * @param {Array} array - Array of objects with consistent keys
 * @returns {string} CSV formatted string
 */
export const convertArrayToCSV = (array) => {
    if (!array || array.length === 0) return '';

    // Extract headers from the first object's keys
    const headers = Object.keys(array[0]);

    // Create header row
    const headerRow = headers.join(',');

    // Create data rows
    const dataRows = array.map(obj => {
        return headers.map(header => {
            const value = obj[header];
            // Escape values containing commas or quotes
            const stringValue = String(value ?? '');
            if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return stringValue;
        }).join(',');
    });

    // Combine header and rows
    return [headerRow, ...dataRows].join('\n');
};

/**
 * Downloads data as a CSV file
 * @param {Array} data - Array of objects to export
 * @param {string} filename - Name of the file to download
 */
export const downloadCSV = (data, filename = 'export.csv') => {
    const csvContent = convertArrayToCSV(data);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};